class TabsManager {
  displayTab(tab, testing = false) {
    if (tab) {
      var el = window.bootstrap.Tab.getOrCreateInstance(document.getElementById("tab-" + tab.code + "-tab")); // Returns a Bootstrap tab instance
      if (!testing) {
        el.show();
      }
    }
  }

  displayRegistrationButton(route, trainingCourseId, isApprenticeOrCompany) {
    return (
      (this.displayTrainingCourseConfigButton(route, trainingCourseId) ||
        this.displayTrainingCourseListButton(route, isApprenticeOrCompany) ||
        route.name === "TrainingCourseList") &&
      !this.isRegistration(route)
    );
  }

  displayTrainingListButton(route, trainingCourseId, isApprenticeOrCompany, user) {
    return (
      (this.displayTrainingCourseConfigButton(route, trainingCourseId) ||
        this.displayTrainingCourseListButton(route, isApprenticeOrCompany) ||
        route.name === "TrainingCourseList") &&
      !this.isStudeaManagerTrainingList(route) &&
      (user.isStudeaManager || user.isAdmin)
    );
  }

  displayTrainingCourseConfigButton(route, trainingCourseId) {
    return (
      trainingCourseId &&
      !this.isStudeaManagerArea(route) &&
      !this.isTrainingCourseList(route) &&
      this.isRouteAvailableForTrainingCourseListButton(route) &&
      !this.isStudeaManagerTraining(route) &&
      !this.isRegistration(route) &&
      !this.isPreRegistration(route)
    );
  }
  displayTrainingCourseListButton(route, isApprenticeOrCompany) {
    return !this.isTrainingCourseList(route) && !isApprenticeOrCompany;
  }

  isStudeaManagerArea(route) {
    return route.matched.some((item) => item.name === "studeaManagerLayout");
  }
  isTrainingCourseList(route) {
    return route.name === "TrainingCourseList";
  }

  isRouteAvailableForTrainingCourseListButton(route) {
    return ![
      "driverLicenceList",
      "trainingCourseDuplicateView",
      "studeaManagerSharedDocumentList",
      "studeaManagerIncidentSheetList",
    ].includes(route.name);
  }

  isStudeaManagerTraining(route) {
    return route.matched.some((item) => item.path === "/training");
  }
  isRegistration(route) {
    return route.matched.some((item) => item.name === "RegistrationLayoutView");
  }
  isPreRegistration(route) {
    return route.matched.some((item) => item.name === "TrainingPreRegistration");
  }

  isStudeaManagerTrainingList(route) {
    return route.name === "TrainingList";
  }

  displayHandleMenuButton(router) {
    return (
      router.currentRoute.value.name !== "TrainingCourseList" &&
      !router.currentRoute.value.matched.find((item) => item.name === "TrainingPreRegistration") &&
      // !router.currentRoute.value.matched.find((item) => item.name === "RegistrationLayoutView") &&
      !router.currentRoute.value.matched.find((item) => item.name === "TrainingLayoutView") &&
      !router.currentRoute.value.matched.find((item) => item.name === "TrainingList") &&
      !router.currentRoute.value.matched.find((item) => item.path === "/studea-manager/shared-document") &&
      !router.currentRoute.value.matched.find((item) => item.path === "/studea-manager/indent-sheet") &&
      !router.currentRoute.value.matched.find((item) => item.path === "/studea-manager/duplication") &&
      !router.currentRoute.value.matched.find((item) => item.path === "/studea-manager/driver-licence") &&
      !router.currentRoute.value.matched.find((item) => item.name === "TrainingDashboard")
    );
  }
}

export const tabsManager = new TabsManager();
